export const stateColors = {
    "COMPLETED": "green",
    "WAITING": "orange",
    "EXPIRED": "red",
    "PROCESSING": "primary"
}

export const priority = {
    "HIGH": "Высокий",
    "DEFAULT": "Обычный",
    "LOW": "Низкий",
}
export const priorityOptions = [
    {
        "label": "Высокий",
        "value": "HIGH"
    },
    {
        "label": "Обычный",
        "value": "DEFAULT"
    },
    {
        "label": "Низкий",
        "value": "LOW"
    }

]


export const states = {
    "COMPLETED": "Выполнена",
    "WAITING": "В ожидании",
    "EXPIRED": "Просрочена",
    "PROCESSING": "В процессе"
}

export const status = {
    "OPEN": "Открыт",
    "CLOSED": "Закрыт",
}

export const statusOptions = [
    {
        "label": "Открыт",
        "value": "OPEN"
    },
    {
        "label": "Закрыт",
        "value": "CLOSED"
    }

]

export const statusColors = {
    "OPEN": "green",
    "CLOSED": "red",
}